import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class HardwareRoute extends AuthenticatedRoute {}
